<template>
  <DashboardContainer name="삼촌 게시판" href="/broadcast" size="w4" line="h2" more="더보기">
    <template v-slot:refresh>
      <a-button size="large" type="link" shape="circle" icon="reload" @click="refresh" />
    </template>

    <div v-if="isLoading" class="card-empty">
      <i class="no-content-logo"></i>
      <p>
        잠시만 기달려주세요.
        <br />정보를 가져오고 있습니다.
      </p>
    </div>

    <div v-else-if="hasError" class="card-empty">
      <i class="no-content-logo"></i>
      <p class="cl-red">{{ hasError }}</p>
    </div>

    <div v-else-if="status.length <= 0" class="card-empty">
      <i class="no-content-logo"></i>
      <p>아직 글이 없습니다.</p>
    </div>

    <ul v-else v-for="(item, index) in status" :key="index">
      <DashboardBroadcastCard
        :idx="item.idx"
        :title="item.title"
        :contents="item.contents"
        :reads="item.reads"
        :author="item.author"
        :uploadAt="$moment(item.uploadAt)"
      />
    </ul>

    <router-link slot="footer" to="/broadcast">
      <div class="card-footer btn_effect ef_type_1 text-center">
        <a>
          <span class="more">+</span>더보기
        </a>
      </div>
    </router-link>
  </DashboardContainer>
</template>
<script>
import Axios from "axios";
import Config from "../../config";
import OPCODE from "../../libs/OPCODE";
import DashboardContainer from "@/components/Dashboard/DashboardContainer";
import DashboardBroadcastCard from "@/components/Dashboard/DashboardBroadcastCard";
import { mapMutations } from "vuex";
import AxiosMiddleware from "../../libs/AxiosMiddleware";

export default {
  name: "DashboardContentBroadcast",
  components: {
    DashboardContainer,
    DashboardBroadcastCard
  },
  data() {
    return {
      isLoading: true,
      hasError: null,
      status: []
    };
  },
  mounted() {
    this.refresh();
  },
  methods: {
    ...mapMutations(["toComma"]),
    refresh: async function() {
      try {
        this.isLoading = true;
        const { data } = await Axios.get(
          `${Config.hostname}/v1/broadcast/status`,
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.status = data.status;
              break;
            default:
              this.hasError = "오류가 발생하였습니다.";
          }
        }
      } catch {
        this.hasError = "인터넷 상태를 확인해주세요.";
      }
      this.isLoading = false;
    }
  }
};
</script>